export const RELIGIONS_TYPEAHEAD_DATA = [
  'African Methodist Episcopal Church',
  'African Methodist Episcopal Zion',
  'Agnostic',
  'American Baptist',
  'American Evangelical Lutheran Church',
  'Anglican',
  'Assemblies of God',
  'Associate Reformed Presbyterian',
  'Association of Vineyard Churches',
  'Atheist',
  "Baha'i",
  'Baptist',
  'Baptist General Conference',
  'Bible',
  'Brethren Church',
  'Buddhism',
  'Caodaiist',
  'Cheondoist',
  'Christ and Missionary Alliance Church',
  'Christian Church (Disciples of Christ)',
  'Christian Churches and Churches of Christ',
  'Christian Reformed Church',
  'Christian Science (Church of Christ, Scientist)',
  'Church of Christ',
  'Church of God (No Regional Affiliation)',
  'Church of God, Anderson',
  'Church of Jesus Christ of Latter Day Saints (Mormon Church)',
  'Church of South India Trust Association',
  'Church of The Brethren',
  'Church of the Nazarene',
  'Church of World Messianity',
  'Churches of Christ in Christian Union',
  'Communion of Reformed Evangelical Churches',
  'Confucianist',
  'Cumberland Presbyterian',
  'Episcopal Church',
  'Evangelical',
  'Evangelical Congregational Church',
  'Evangelical Covenant Church of America',
  'Evangelical Free Church',
  'Evangelical Lutheran Church In America',
  'Fellowship of Grace Brethren Churches',
  'Free Methodist',
  'Free Will Baptist Church',
  'Friends / Society of Friends (Quaker)',
  'Greek Orthodox',
  'Hinduism',
  'Interdenominational',
  'International Central Gospel Church',
  'International Pentecostal Holiness Church',
  'Islam',
  'Jain',
  "Jehovah's Witnesses",
  'Jewish - Conservative',
  'Jewish - Orthodox',
  'Jewish - Reformed',
  'Korean Evangelical Holiness Church',
  'Lutheran Church in America',
  'Lutheran Church Missouri Synod',
  'Mennonite Brethren Church',
  'Mennonite Church',
  'Methodist',
  'Missionary Church Inc',
  'Moravian Church',
  'Multiple Protestant Denomination',
  'No Preference or Affiliation / None',
  'Nondenominational - Christian',
  'North American Baptist',
  'Original Free Will Baptist',
  'Other',
  'Other - Catholic Christian',
  'Other - Jewish',
  'Other - Orthodox Christian',
  'Other - Protestant Christian',
  'Pentecostal Assemblies of the World',
  'Prefer Not to Answer',
  'Presbyterian',
  'Presbyterian Church (USA)',
  'Presbyterian Church in America',
  'Presbyterian Church of Korea',
  'Protestant Episcopal',
  'Rastafari',
  'Reformed Church in America',
  'Reformed Presbyterian Church',
  'Roman Catholic Church',
  'Russian Orthodox',
  'Scientology',
  'Seicho-no-Ie-ist',
  'Seventh Day Adventist',
  'Sikhism',
  'Shinto',
  'Southern Baptist Convention',
  'Taoist',
  'Tenrikyoist',
  'The Christian & Missionary Alliance',
  'The Presbyterian Church in America',
  'Unitarian Universalist Association',
  'United Brethren Church',
  'United Church of Christ',
  'United Methodist Church',
  'United Pentecostal Church International',
  'Wesleyan Church',
  'Wiccan (Pagan)',
  'Wisconsin Evangelical Lutheran Synod',
  'Worldwide Church of God / Grace Communion International',
  'Yazidi',
];
